import React from "react";
import { InstagramSVG, LinkedInSVG, TikTokSVG } from "../SVGs/SocialSVGs";
import { Link } from "react-router-dom";

const socialLinks = [
  { href: "https://www.instagram.com/arsenunair", icon: <InstagramSVG width="18" height="18" />, label: "Instagram" },
  { href: "https://www.linkedin.com/company/linkedinairlanggastatisticsevent/", icon: <LinkedInSVG width="18" height="18" />, label: "LinkedIn" },
  { href: "https://www.tiktok.com/@arsenunair", icon: <TikTokSVG width="18" height="18" />, label: "TikTok" },
];

const footerLinks = [
  { label: "Himpunan Mahasiswa Statistika UNAIR", href: "https://himastaunair.com" },
  { label: "Program Studi Statistika, Universitas Airlangga", href: "https://stat.fst.unair.ac.id" },
  { label: "Universitas Airlangga", href: "https://unair.ac.id" },
];

function Footer() {
  return (
    <footer className="bg-arsen-quaternary-950 text-white">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">

        {/* Brand column */}
        <div className="flex flex-col gap-5">
          <div className="flex items-center gap-2.5">
            <img
              src="/assets/img/logo/arsen2026-icon.png"
              alt=""
              className="h-10 w-10 object-contain"
            />
            <span className="font-extrabold text-lg tracking-wide">
              ARS<span className="text-arsen-sky-300">Σ</span>N UNAIR
            </span>
          </div>
          <p className="text-sm text-white/60 leading-relaxed">
            Airlangga Statistics Events (ARSEN) — ajang perlombaan bergengsi yang diselenggarakan oleh HIMASTA Universitas Airlangga.
          </p>
          <div className="flex gap-3">
            {socialLinks.map((s) => (
              <Link
                key={s.label}
                to={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/60 hover:text-white hover:border-white/60 hover:bg-white/10 transition-all duration-200"
              >
                {s.icon}
              </Link>
            ))}
          </div>
        </div>

        {/* Contact column */}
        <div className="flex flex-col gap-4">
          <h3 className="text-sm font-bold tracking-widest text-white/40 uppercase">Kontak</h3>
          <div className="flex flex-col gap-2 text-sm text-white/70">
            <p className="font-medium text-white/90">Sekretariat HIMASTA UNAIR</p>
            <p className="leading-relaxed">
              Fakultas Sains dan Teknologi, Universitas Airlangga — Kampus C, Mulyorejo, Surabaya 60115
            </p>
          </div>
          <div className="flex flex-col gap-1.5 text-sm text-white/70">
            <p className="text-white/40 text-xs font-semibold uppercase tracking-wider">Narahubung</p>
            <Link to="http://wa.me/6285232992310" className="hover:text-white transition-colors">
              WhatsApp: +62 852-3299-2310 (Vani)
            </Link>
            <Link to="mailto:arsenunair2026@gmail.com" className="hover:text-white transition-colors">
              arsenunair2026@gmail.com
            </Link>
          </div>
          <div className="flex flex-col gap-1.5 text-sm text-white/70">
            <p className="text-white/40 text-xs font-semibold uppercase tracking-wider">Sponsor Kami</p>
            <Link to="http://wa.me/6281249127845" className="hover:text-white transition-colors">
              WhatsApp: +62 812-4912-7845 (Prima)
            </Link>
          </div>
        </div>

        {/* Links column */}
        <div className="flex flex-col gap-4">
          <h3 className="text-sm font-bold tracking-widest text-white/40 uppercase">Tautan</h3>
          <ul className="flex flex-col gap-2">
            {footerLinks.map((l) => (
              <li key={l.href}>
                <Link
                  to={l.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-white/70 hover:text-white transition-colors flex items-start gap-2"
                >
                  <span className="mt-0.5 text-arsen-sky-300 shrink-0">→</span>
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 py-4 flex flex-col sm:flex-row justify-between items-center gap-2 text-xs text-white/40">
          <span>&copy; 2026 Airlangga Statistics Events (ARSEN). All rights reserved.</span>
          <span>HIMASTA Universitas Airlangga</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
